import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Objetivo = () => {
  return (
    <section className="objetivo-section">
      <Container>
        <Row>
          <Col md={10} className="mx-auto text-center">
            <Row className="gy-4">
              <Col md={6}>
                <div className="objetivo-card text-start">
                  <h3>
                    Nuestra
                    <br />
                    inspiración
                  </h3>
                  <p className="pt-3">
                    Nos inspiran los <strong>hombres y mujeres</strong> que con su esfuerzo y dedicación
                    <strong> construyen el futuro de nuestro país</strong>. Y de las <strong>empresas</strong> que no
                    solo buscan el <strong>éxito</strong>, sino que <strong>se preocupan por sus colaboradores</strong>.
                  </p>
                </div>
              </Col>
              <Col md={6}>
                <div className="objetivo-card text-start">
                  <h3>
                    Nuestro
                    <br />
                    objetivo
                  </h3>
                  <p className="pt-3">
                    Es crear conciencia en todos los mexicanos de la importancia de estar protegido en todos los
                    sentidos.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Objetivo;
